import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PopupService } from './services/popup.service';
import { PageLoadingService } from './services/page-loading.service';

@Injectable()
export class ErrorHandleHttpInterceptor implements HttpInterceptor {
  constructor(
    private popupService: PopupService,
    private pageLoadingService: PageLoadingService
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 0) {
          window.location.href = '/MicrosoftIdentity/Account/SignIn';
        } else if (err.status === 403) {
          this.popupService.snackbar('權限不足！');
        } else if (err.status === 409) {
          // 與後端協調，若返回 409 則為需自行處理錯誤內容。
          return throwError(err);
        } else {
          let message: string;
          if (err.error.message === undefined && !!err.error.errors) {
            message = Object.values(err.error.errors).reduce(
              (x: string, y: string) => x + ', ' + y
            ) as string;
          } else {
            message = err.error.message;
          }
          this.popupService.snackbar(message);
        }
        this.pageLoadingService.loaded();
        return of(null);
      })
    );
  }
}
